import type { ProviderAddressResponse, AddressSearchValue } from './interfaces'

export function mapProviderResponseToSearchValue(
  response: ProviderAddressResponse
): AddressSearchValue {
  return {
    address: response.streetAddress || response.address,
    lat: response.lat,
    lng: response.lng,
    streetAddress: response.streetAddress,
    fullAddress: response.address,
    city: response.city,
    state: response.state,
    zip: response.zip,
    bbox: response.bbox ?? null,
    placeType: response.place_type ?? null
  }
}
